import React from 'react';
import PropTypes from 'prop-types';
import { WIZARD_STEP } from 'constants/wizardConstants';
import TabContents from './TabContents';
import BodyContents from './BodyContents';
import SetupStatus from './SetupStatus';
import SetupFinished from './SetupFinished';
import SetupGuide from './SetupGuide';

export const MainContents = ({ step, setStep }) => {
  return (
    <>
      {step < WIZARD_STEP.STATUS && (
        <>
          <TabContents step={step} />
          <div className="right">
            <BodyContents step={step} />
          </div>
        </>
      )}
      {step === WIZARD_STEP.STATUS && <SetupStatus step={step} setStep={setStep} />}
      {step === WIZARD_STEP.FINISHED && <SetupFinished step={step} setStep={setStep} />}
      {step === WIZARD_STEP.GUIDE_1 && <SetupGuide step={step} />}
      {step === WIZARD_STEP.GUIDE_2 && <SetupGuide step={step} />}
      {step === WIZARD_STEP.GUIDE_3 && <SetupGuide step={step} />}
    </>
  );
};
MainContents.propTypes = {
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
};
MainContents.defaultProps = {};
export default MainContents;
